import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { EventsService, VariablesService } from '../../../shared/services';

@Component({
  selector: 'app-redirect-link',
  templateUrl: './redirect-link.component.html',
  styleUrls: ['./redirect-link.component.scss']
})
export class RedirectLinkComponent implements OnInit {

  @Input() label: string;
  @Input() link;
  @Input() icon;
  @Input() paramsHandling;
  @Output() redirectOut = new EventEmitter();

  constructor(
    private eventsService: EventsService,
    private variablesService: VariablesService
  ) { }

  ngOnInit() {
  }

  clickListner() {
    if (this.link === '.') {
      this.redirectOut.emit(true);
    }
    this.goToPortfolioTrack();
  }

  /*Tracking code for thank you page on go to your portfolio button */
  goToPortfolioTrack() {
    const payload = {
      'eventName': 'view_impact',
      'info_1': 'position',
      'info_2': '37',
      'info_3': this.variablesService.campaignType,
      'page_name': this.variablesService.pageName,
    };
    this.eventsService.sendSystemEvent(payload).subscribe(_ => _);
  }

}
